import { rpcClient } from "@/api/WebsocketClient"
import { reactive } from '@vue/reactivity'
import ResourceShare from '@/model/common/ResourceShare';


export default class GeneratedResourceShareStore {

    state: {
        resourceShares: Map<number, ResourceShare>,
        calls: Map<string, number | number[]>
    }
    timer: number | null = null

    constructor() {
        let resourceShares: Map<number, ResourceShare> | null = null
        try {
            const persistedState = localStorage.getItem('ResourceShareStore')
            if (persistedState) {
                resourceShares = new Map(JSON.parse(persistedState))
            }
        } catch (ignore) {}
        this.state = reactive({
            resourceShares: resourceShares || new Map<number, ResourceShare>(),
            calls: new Map<string, number | number[]>()
        })
        this.init()
    }

    init() {
        window.setTimeout(() => {
            if (rpcClient) {
                rpcClient.stores.push(this)
            } else {
                this.init()
            }
        }, 1)
    }

    persistState() {
        if (this.timer === null) {
            setTimeout(() => {
                localStorage.setItem('ResourceShareStore', JSON.stringify(Array.from(this.state.resourceShares)))
                this.timer = null
            }, 1000)
        }
    }

    clearState() {
        if (this.timer) clearTimeout(this.timer)
        if (this.state?.resourceShares) this.state.resourceShares.clear()
        if (this.state?.calls) this.state.calls.clear()
        localStorage.removeItem('ResourceShareStore')
    }

    addOrReplaceResourceShare(newResourceShare: ResourceShare, persist: boolean = true): true | undefined {
        if (newResourceShare.id) {
            this.state.resourceShares.set(newResourceShare.id, newResourceShare)
            
            if (persist) {
                this.persistState()
            } else {
                return true
            }
        }
    }
    
    addOrReplaceResourceShares(newResourceShares: ResourceShare[]) {
        let persist = false
        for (const newResourceShare of newResourceShares) {
            const changed = !!this.addOrReplaceResourceShare(newResourceShare, false)
            persist = persist || changed
        }
        if (persist) {
            this.persistState()
        }
    }

    replaceResourceShares(resourceShares: ResourceShare[]) {
        const newResourceShares = new Map<number, ResourceShare>()
        for (const newResourceShare of resourceShares) {
            if (newResourceShare.id) {
                newResourceShares.set(newResourceShare.id, newResourceShare)
                
            }
        }
        this.state.resourceShares = newResourceShares
        this.persistState()
    }

    removeResourceShare(id: number | undefined | null, persist: boolean = true): true | undefined {
        if (id !== undefined && id !== null) {
            if (this.state.resourceShares.delete(id)) {
                if (persist) {
                    this.persistState()
                } else {
                    return true
                }
            }
        }
    }

    removeResourceShares(ids: (number | null)[] | undefined | null) {
        let persist = false
        if (ids !== undefined && ids !== null) {
            for (const id of ids) {
                const changed = !!this.removeResourceShare(id, false)
                persist = persist || changed
            }
        }
        if (persist) {
            this.persistState()
        }
    }
}